import { AiTool as McpTool } from '@carto/meridian-ds/custom-icons'
import { styled } from '@mui/material'
import { showMcpToolDialog } from '../../Dialogs'
import { Workflow, WorkflowListItem } from 'features/workflows/types'
import WorkflowFeatureBadge from './WorkflowFeatureBadge'
import { useMcpToolEnabled } from 'features/workflows/utils/mcpTool'

interface Props {
  workflow: Workflow | WorkflowListItem
  compact?: boolean
  alert?: boolean
}

const McpToolIcon = styled(McpTool)(({ theme }) => ({
  width: theme.spacing(1.5)
}))

function WorkflowMcpToolEnabled({ workflow, compact = false, alert = false }: Props) {
  return (
    <WorkflowFeatureBadge
      workflow={workflow}
      compact={compact}
      alert={alert}
      conditionCheck={useMcpToolEnabled}
      icon={compact ? <McpTool /> : <McpToolIcon />}
      labelId="workflows.mcpTool.tagText"
      onClick={showMcpToolDialog}
      zIndex={1}
    />
  )
}

export default WorkflowMcpToolEnabled
